import type { ValueVsSpendMetrics } from '@/hooks/queries/useAnalyticsQueries';

/**
 * Demo data for `isDummyUser` mode. Kept side-by-side here so the brand and
 * individual variants stay visually comparable and don't silently drift when
 * one is edited without the other.
 *
 * These mirror what the backend ValueVsSpend endpoint returns. The only
 * hardcoded inputs are spend, sales, participant count, the per-creator CGC
 * rate and the seeded EMV; CGC, total campaign value, ROI and ROAS are DERIVED
 * so they can't drift from the inputs.
 */
const CGC_RATE_EUR = 150; // creator-generated-content value per approved post
const DUMMY_TOTAL_EMV = 17_733.54; // compute-on-read EMV for the seeded engagement

const spent = 1840; // Cashback Paid (totalSpent) — matches the Active Campaign card
const sales = 4600; // Total Sales — matches the Active Campaign card
const count = 92; // approved cashback count / participants
const cgc = CGC_RATE_EUR * count; // €150 × 92 = 13,800
const totalCampaignValue = DUMMY_TOTAL_EMV + cgc + sales; // 36,133.54

const DUMMY_CAMPAIGN_VALUE_VS_SPEND: ValueVsSpendMetrics = {
  roi: Number((totalCampaignValue / spent).toFixed(2)), // ≈ 19.64
  averageRoas: Number((sales / spent).toFixed(2)), // 2.5
  totalCampaignValue: totalCampaignValue.toFixed(2),
  cgc: cgc.toFixed(2),
  totalEmv: DUMMY_TOTAL_EMV.toFixed(2),
  totalSales: sales.toFixed(2),
  totalSpent: spent,
  approvedCashbackCount: count,
};

export const DUMMY_VALUE_VS_SPEND_BRAND: ValueVsSpendMetrics = {
  ...DUMMY_CAMPAIGN_VALUE_VS_SPEND,
};

export const DUMMY_VALUE_VS_SPEND_INDIVIDUAL: ValueVsSpendMetrics = {
  ...DUMMY_CAMPAIGN_VALUE_VS_SPEND,
};
